import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function RateCardEditorMenu({
    anchorEl,
    open,
    onClose,
    card,
    onRename,
    onViewSkillMap,
    onExportCsv,
    onImportCsv,
    onDuplicate,
    onArchive,
}) {
    return (
        <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
            <If value={onRename}>
                <MenuItem onClick={onRename}>
                    <ListItemIcon>
                        <Iconify icon="solar:pen-bold" width={20} />
                    </ListItemIcon>
                    <ListItemText>Edit Details</ListItemText>
                </MenuItem>
            </If>
            <If value={card.skillMapId}>
                <MenuItem onClick={onViewSkillMap}>
                    <ListItemIcon>
                        <Iconify icon="icon-park-twotone:mind-mapping" width={20} />
                    </ListItemIcon>
                    <ListItemText>View Skill Map</ListItemText>
                </MenuItem>
            </If>
            <MenuItem onClick={onExportCsv}>
                <ListItemIcon>
                    <Iconify icon="solar:document-text-bold" width={20} />
                </ListItemIcon>
                <ListItemText>Export CSV</ListItemText>
            </MenuItem>
            <If value={onImportCsv}>
                <MenuItem onClick={onImportCsv}>
                    <ListItemIcon>
                        <Iconify icon="solar:upload-bold" width={20} />
                    </ListItemIcon>
                    <ListItemText>Import CSV</ListItemText>
                </MenuItem>
            </If>
            <If value={onDuplicate}>
                <MenuItem onClick={onDuplicate}>
                    <ListItemIcon>
                        <Iconify icon="solar:copy-bold" width={20} />
                    </ListItemIcon>
                    <ListItemText>Duplicate</ListItemText>
                </MenuItem>
            </If>
            <If value={onArchive}>
                <MenuItem onClick={onArchive}>
                    <ListItemIcon>
                        <Iconify icon="solar:archive-bold" width={20} />
                    </ListItemIcon>
                    <ListItemText>Archive</ListItemText>
                </MenuItem>
            </If>
        </Menu>
    )
}
